import React, { Component } from 'react';

export class LoadingPage extends Component {

    render(){
        //const { hasError, errorMessage } = this.props;

        return(
            <div className="loading-page">
                <div className="message-container">
                    <h1>Chargement <span className="dot-loader"></span></h1>
                    
                </div>
                <div className="spinner-loader">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div> 
            </div>
        )
    }
}

export default LoadingPage;


// WEBPACK FOOTER //
// ./src/components/Loader/LoadingPage.js